module.exports = __webpack_public_path__ + "static/media/low_priority.9785c8d5.svg";